import { render } from "./NavBarPill.vue?vue&type=template&id=0b38cad7&scoped=true"
import script from "./NavBarPill.vue?vue&type=script&lang=js"
export * from "./NavBarPill.vue?vue&type=script&lang=js"

import "./NavBarPill.vue?vue&type=style&index=0&id=0b38cad7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b38cad7"],['__file',"src/scripts/common/editorNavBar/NavBarPill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b38cad7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b38cad7', __exports__)) {
    api.reload('0b38cad7', __exports__)
  }
  
  module.hot.accept("./NavBarPill.vue?vue&type=template&id=0b38cad7&scoped=true", () => {
    api.rerender('0b38cad7', render)
  })

}


export default __exports__